export enum IncomeAndOpexCalculationMethods {
  "total" = "total",
  "per sf" = "per sf",
  "per unit" = "per unit",
}
